'use strict';

export default class OPLAzureSearch {
    constructor() {
        this.azureSearchObj = null;
        this.datePickers = {};
        this.triggerDateChange = true;
        this.applyingDates = false;
        this.searchResultsContainer = null;
        this.props = {
            urlBase: '/'
        };
    }

    initAndRunSearch(options) {
        // Please do not remove the comment below because Webpack needs the chunk name to dynamically load this library.
        import(/* webpackChunkName: "TPSAzureSearch" */ '../../tps-azuresearch/dist/index').then(module => {
            const TPSAzureSearch = module.default;

            this.azureSearchObj = new TPSAzureSearch(options);
            this.azureSearchObj.search();

            this.searchResultsContainer = options.results.container instanceof Element ? options.results.container : document.querySelector(options.results.container);
            this.setupFacetAccordions();

            if (options.dates && options.dates.hasDates) {
                this.setupDatepickers(options.dates);
            }

            this.setupViewToggles();
        });
    }

    clearAllFilters(clearDates = true) {
        this.azureSearchObj.clearAppliedFacets();
        if (clearDates) {
            this.applyingDates = true;
            this.datePickers['from'].clearSelection();
            this.datePickers['to'].clearSelection();
        }
    }

    setupFacetAccordions() {
        const facetsLists = document.querySelectorAll('.opl-azure-search-facet-list');

        const handleFacetTitleClick = (e) => {
            if (e.target.classList.contains('opl-azure-search-facet-group-title') && e.target.hasAttribute('aria-controls')) {
                if (e.target.ariaExpanded === 'true') {
                    e.target.ariaExpanded = 'false';
                } else {
                    e.target.ariaExpanded = 'true';
                }
            }
        };

        facetsLists.forEach(facetList => {
            facetList.addEventListener('click', (e) => {
                handleFacetTitleClick(e);
            });
            facetList.addEventListener('keyup', (e) => {
                if (e.key === 'Enter') {
                    handleFacetTitleClick(e);
                }
            });
        });
    }

    setDate(selector, type) {
        if (!type) return;

        const currentDate = new Date();
        const start = currentDate.setHours(0, 0, 0, 0);

        if (type === 'today') {
            const end = currentDate.setHours(23, 59, 59, 999);
            this.applyingDates = true;
            // uses setDate from litepicker datepicker library
            this.datePickers['from'].setDate(start);
            this.datePickers['to'].setDate(end);
        } else if (type === 'upcoming') {
            this.applyingDates = true;
            // uses setDate/clearSelection from litepicker datepicker library
            this.datePickers['from'].setDate(start);
            this.datePickers['to'].clearSelection();
        } else if (type === 'all') {
            this.applyingDates = true;
            // uses clearSelection from litepicker datepicker library
            this.datePickers['from'].clearSelection();
            this.datePickers['to'].clearSelection();
        }

        const todayUpcomingButtons = document.querySelectorAll('.opl-azure-search-controls-actions-todayupcoming button');
        todayUpcomingButtons.forEach(button => {
            button.classList.remove('active');
        });
        const activeButton = document.querySelector(selector);
        if (activeButton) {
            activeButton.classList.add('active');
        }
    }

    setupViewToggles() {
        const viewToggles = document.querySelectorAll('[data-search-results-view-toggle]');

        viewToggles.forEach(toggle => {
            const className = toggle.dataset.searchResultsViewToggle;
            const targetContainer = document.querySelector(toggle.dataset.searchResultsViewToggleTarget);

            toggle.addEventListener('click', () => {
                viewToggles.forEach(t => {
                    const tClassName = t.dataset.searchResultsViewToggle;

                    if (className === tClassName) {
                        targetContainer.classList.add(tClassName);
                        t.classList.add('active');
                    } else {
                        targetContainer.classList.remove(tClassName);
                        t.classList.remove('active');
                    }
                });
            });
        });
    }

    setupDatepickers(dateOptions) {
        const addPickerEvents = (picker) => {
            const target = picker.options.element;

            const handleLitepickerSelectAndClear = () => {
                if (!this.applyingDates) {
                    // should the date change tigger the change event?
                    // sometimes we want to clear the field, or update the date without
                    // making another request to the index
                    if (this.triggerDateChange) {
                        target.dispatchEvent(new Event('change'));
                    }

                    const todayUpcomingButtons = document.querySelectorAll('.opl-azure-search-controls-actions-todayupcoming button');
                    todayUpcomingButtons.forEach(button => {
                        button.classList.remove('active');
                    });
                } else {
                    this.applyingDates = false;
                }
            };

            picker.on('selected', handleLitepickerSelectAndClear);
            picker.on('clear:selection', handleLitepickerSelectAndClear);
            picker.on('before:show', () => {
                this.datePickers['from'].hide();
                this.datePickers['to'].hide();
            });
        };

        const fromElement = document.querySelector(dateOptions.fields.from.inputSelector);

        if (fromElement) {
            window.OPL.Utility.initLitepicker(fromElement).then(picker => {
                this.datePickers.from = picker;
                addPickerEvents(picker);
            });
        }

        if (dateOptions.fields.to) {
            const toElement = document.querySelector(dateOptions.fields.to.inputSelector);
            if (toElement) {
                window.OPL.Utility.initLitepicker(toElement).then(picker => {
                    this.datePickers.to = picker;
                    addPickerEvents(picker);
                });
            }
        }
    }

    createResultItemTemplate_communico(item) {
        return this.createCommunicoResult(item);
    }

    createResultItemTemplate_opl(item) {
        return this.createOplResult(item);
    }

    createResultItemTemplate_sirsi(item) {
        return this.createSirsiResult(item);
    }

    createResultItemTemplate_hip(item) {
        return this.createHipResult(item);
    }

    createOplResult(item) {
        const summaryText = item.summary ? `<div class="opl-azure-search-results-item-description">${item.summary}</div>` : '';
        const url = item.classname === 'oplcustom.resource' ? item.resourcelink : item.nodealiaspath;
        return `<a href="${url}" target="_blank" class="opl-azure-search-results-item opl">
                    <div class="opl-azure-search-results-item-details">
                        <div class="opl-azure-search-results-item-title">${item.pagename}</div>
                        ${summaryText}
                        <div class="opl-azure-search-results-item-link">View the Page</div>
                    </div>
                </a>`;
    }

    createSirsiResult(item) {
        const authors = item.mediaauthors ? `<div class="opl-azure-search-results-item-authors"><em>By ${item.mediaauthors}</em></div>` : '';
        const date = item.mediapublicationdate ? `<div class="opl-azure-search-results-item-year"><strong>Year:</strong> ${item.mediapublicationdate}</div>` : ''
        const subtitle = item.subtitle ? `<div class="opl-azure-search-results-item-subtitle">${item.subtitle}</div>` : '';
        const formatText = item.mediaformatname ? `<div class="opl-azure-search-results-item-format"><strong>Format:</strong> ${item.mediaformatname}</div>` : '';

        let defaultImageSrc = this.setDefaultImage(item.mediaformatid);

        let html = `
                <a href="${item.url}" target="_blank" class="opl-azure-search-results-item sirsi">
                    <div class="opl-azure-search-results-item-image-wrapper">
                        <img src="${defaultImageSrc}" alt="" class="opl-azure-search-results-item-image" id="item-img-${item.internalid}">
                    </div>
                    <div class="opl-azure-search-results-item-details">
                        <div class="opl-azure-search-results-item-title">${item.title}</div>
                        ${subtitle}
                        ${authors}

                        <div class="opl-azure-search-results-item-details-inner">
                            ${formatText}
                            ${date}
                        </div>
                        <div class="opl-azure-search-results-item-availability"><strong>Availability:</strong> ${item.mediaavailability}</div>
                        <div class="opl-azure-search-results-item-link">View Details</div>
                    </div>
                </a>
            `;

        if (item.image) {
            this.checkItemImage(item.image, item.mediaformatid, `#item-img-${item.internalid}`);
        }

        return html;
    }

    createHipResult(item) {
        return `
            <a href="${item.url}" target="_blank" class="opl-azure-search-results-item hip">
                    <div class="opl-azure-search-results-item-details">
                    <div class="opl-azure-search-results-item-title">${item.title}</div>
                    <div class="opl-azure-search-results-item-description">${item.description}</div>
                    <div class="opl-azure-search-results-item-link">View this resource</div>
                </div>
            </a>
        `;
    }

    createCommunicoResult(item) {
        const currentDate = new Date();
        const startDate = new Date(item.EventStart);
        const endDate = item.EventEnd ? new Date(item.EventEnd) : null;
        const isPastEvent = startDate < currentDate;
        const isCanceled = item.EventModified === 'canceled';
        const isRescheduled = item.EventModified === 'rescheduled';
        const formattedDateString = this.getEventDateString(startDate, endDate);
        const location = item.EventLocationName;
        const roomName = item.EventRoomName;
        const locationText = roomName ? `${location} - ${roomName}` : location;
        const ages = item.EventAges.length > 0 ? item.EventAges.toString().replace(',', ', ') : '';

        const subTitle = item.subtitle ? `<div class="opl-azure-search-results-item-subtitle">${item.subtitle}</div>` : '';

        const agesText = ages != '' ? `<div class="opl-azure-search-results-item-ages"><strong>Ages:</strong> ${ages}</div>` : '';

        

        let statusTag = '';
        if (isCanceled || isPastEvent || isRescheduled) {
            const statusTagText = isCanceled ? 'Canceled' : isRescheduled ? 'Rescheduled' : isPastEvent ? 'Past Event' : '';
            statusTag = `<div class="opl-azure-search-results-item-tag opl-azure-search-results-item-tag-${item.EventModified}">${statusTagText}</div>`;
        }
            
        const registrationOpenDate = new Date(item.EventRegistrationOpens);
        const registrationCloseDate = new Date(item.EventRegistrationCloses);
        const isRegistrationOpen = registrationOpenDate < currentDate && registrationCloseDate > currentDate;

        const buttonLabel = item.EventRegistration || item.EventThirdpartyRegistration || isRegistrationOpen ? 'Register Here' : 'Learn More';

        return `<a href="${item.url}" class="opl-azure-search-results-item results-card ${isPastEvent ? 'past-event' : 'upcoming-event'}${isCanceled ? ' canceled-event' : ''}" target="_blank" rel="noopener noreferrer">
            <div class="opl-azure-search-results-item-details">
                <div class="opl-azure-search-results-item-title">${item.title}</div>
                ${subTitle}
                ${statusTag}
                <div class="opl-azure-search-results-item-date" data-date="${startDate.toLocaleTimeString()}">${formattedDateString}</div>
                <div class="opl-azure-search-results-item-location">${locationText}</div>
                ${agesText}
            </div>
            <div class="opl-azure-search-results-item-actions">
                <div class="opl-azure-search-results-item-link btn btn-yellow">${buttonLabel}</div>
            </div>
        </a>`;
    }

    getEventDateString(startDate, endDate) {
        const dateOptions = {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        };

        const timeOptions = {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        };

        const dateStr = new Intl.DateTimeFormat('en-US', dateOptions).format(startDate);
        const startTimeStr = new Intl.DateTimeFormat('en-US', timeOptions).format(startDate);
        const endTimeStr = endDate ? new Intl.DateTimeFormat('en-US', timeOptions).format(endDate) : '';

        return endTimeStr
            ? `${dateStr}, ${startTimeStr} - ${endTimeStr}`
            : `${dateStr}, ${startTimeStr}`;
    }

    createResourceResult(item) {
        let itemLabel = this.azureSearchObj.config.results.labels.itemLabels['public'];
        let itemUrl = item.resourcelink;
        let itemTarget = `target="_blank"`;
        let itemClass = 'opl-azure-search-results-item opl';

        // check if the cardDetail object exists + the resource is gated
        if (this.azureSearchObj.config._c && item.resourcerequiressso === 'true') {

            if (!this.azureSearchObj.config._c._a) {
                itemLabel = this.azureSearchObj.config.results.labels.itemLabels['public_gated'];
                itemUrl = this.azureSearchObj.config.results.labels.gatedItemUrls['public_gated'];
            } else if (this.azureSearchObj.config._c._e) {
                itemLabel = this.azureSearchObj.config.results.labels.itemLabels['gated_expired'];
                itemUrl = this.azureSearchObj.config.results.labels.gatedItemUrls['gated_expired'];
                itemClass += ' item-unavailable'
            } else if (this.azureSearchObj.config._c._b) {
                itemLabel = this.azureSearchObj.config.results.labels.itemLabels['gated_restricted'];
                itemUrl = 'javascript:void(0)';
                itemTarget = ``;
                itemClass += ' item-restricted'
            }

        }

        const _summaryText = item.summary ? `<div class="opl-azure-search-results-item-description">${item.summary}</div>` : '';

        const _itemHTML = `<a href="${itemUrl}" ${itemTarget} class="${itemClass}">
                    <div class="opl-azure-search-results-item-details">
                        <div class="opl-azure-search-results-item-title">${item.pagename}</div>
                        ${_summaryText}
                        <div class="opl-azure-search-results-item-link">${itemLabel}</div>
                    </div>
                </a>`;

        return _itemHTML;

    }

    resetKeywordForm(event) {
        event.preventDefault();

        const form = event.target;
        [...form.elements].forEach(element => {
            if (element.type === 'radio' || element.type === 'checkbox') {
                element.checked = false;
            } else if (element.type !== 'reset' && element.type !== 'submit') {
                element.value = '';
            }
        });

        form.submit();
    }

    getPageSize(selector) {

        if (!selector || typeof selector !== 'string')
            return;

        const pageSizeSelect = document.querySelector(selector);
        let pageSize = 5;

        if (pageSizeSelect) {
            const pageSizeSelectValue = parseInt(pageSizeSelect.value);
            if (!isNaN(pageSizeSelectValue))
                pageSize = pageSizeSelectValue;
        }

        return pageSize;
    }

    setupPageSizeOptions(selector) {
        const pageSizeSelect = document.querySelector(selector);

        // if there is no pagesize select, STOP
        if (!pageSizeSelect)
            return;

        let pageSizeOpts = [5, 10, 15];

        if (window.innerWidth >= 768) {
            pageSizeOpts = [25, 50, 100];
        }

        // first empty the select
        pageSizeSelect.innerHTML = "";

        // then add the options from the array
        pageSizeOpts.forEach((v) => {
            const option = document.createElement('option');
            option.value = v;
            option.label = v;
            pageSizeSelect.append(option);
        });
    }

    addPagerMessage(pager, currentPage, totalResults, pageSize) {
        if (pager) {

            // if there is no pagination
            // then we will hide the parent
            if (pager.innerHTML === '') {
                pager.parentElement.classList.remove('active');
            }
            else {
                var pBottom = currentPage;
                var pTop = currentPage * pageSize;
                if (pBottom > 1) {
                    pBottom = ((currentPage - 1) * pageSize) + 1;
                }
                if (pTop > totalResults) {
                    pTop = totalResults;
                }

                pager.parentElement.classList.add('active');

                const pagerMsg_elem = document.createElement('div');
                pagerMsg_elem.classList.add('pager-navs-msg');
                pagerMsg_elem.innerHTML = `<span>${pBottom}</span>-<span>${pTop}</span> of <span>${totalResults}</span>`;
                const pagerNext = pager.querySelector('.pager-next');

                if (pagerNext) {
                    pager.insertBefore(pagerMsg_elem, pagerNext);
                }
                else {
                    pager.append(pagerMsg_elem);
                }
            }
        }
    }

    setDefaultImage(format) {
        const bookFormats = ['BB', 'BOOK', 'EBOOK', 'EMAG', 'EREF', 'GR', 'KIT', 'LP', 'MAG', 'MAP', 'PB', 'UNKNOWN'];
        const moviesFormats = ['BLURAY', 'DVD', 'EVIDEO', 'GAME', 'MISC'];
        const musicFormats = ['BCD', 'CD', 'EAUDIO', 'EMUSIC', 'MP3', 'TB'];

        // check what format group, to choose the default image
        const img_grp = bookFormats.indexOf(format) > -1 ? 'BOOKS' : moviesFormats.indexOf(format) > -1 ? 'MOVIES' : musicFormats.indexOf(format) > -1 ? 'MUSIC' : '';

        let img_src = '';

        // if the item does not have an image in the index
        // and its format is in one of the above groups
        // then show the default image configured in kentico
        if (img_grp) {
            img_src = this.props.defaultImages[img_grp] ? this.props.defaultImages[img_grp] : '';
        }


        return img_src;
    }

    async getImageSize(url) {
        const img = new Image();
        img.src = url;
        await img.decode();

        return {
            width: img.width,
            height: img.height
        };
    }

    checkItemImage(imgSrc, formatId, elemSelector) {
        // Try loading the actual image
        const testImg = new Image();
        testImg.src = imgSrc;

        testImg.onload = () => {
            if (testImg.width > 1 && testImg.height > 1) {
                const elem = document.querySelector(elemSelector);
                if (!elem) return;
                elem.src = imgSrc;
            }
        };

        testImg.onerror = () => {
            // Image failed to load - fallback already applied
            console.warn(`Image failed to load: ${imgSrc}`);
        };
    }
}
